import { useEffect, useState } from "react";
import { usePrivy } from "@privy-io/react-auth";
import { StepDialog } from "./StepDialog";
import { REPLAY_ONBOARDING_EVENT } from "./ReplayTutorialControl";
import {
  getOnboardingLoggedInDialogSteps,
  getOnboardingLoggedOutDialogSteps,
} from "@/lib/constants";
import { usePrivyCustom } from "@/lib/hooks/usePrivyCustom";

export function ReplayTutorialDialog() {
  const { user } = usePrivy();
  const { login } = usePrivyCustom();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleReplay = () => setIsOpen(true);
    window.addEventListener(REPLAY_ONBOARDING_EVENT, handleReplay);
    return () =>
      window.removeEventListener(REPLAY_ONBOARDING_EVENT, handleReplay);
  }, []);

  return (
    <>
      {!user && (
        <StepDialog
          isOpen={isOpen}
          steps={getOnboardingLoggedOutDialogSteps()}
          preventOutsideDismiss
          mode="fullscreen"
          onClose={() => setIsOpen(false)}
          onLastAction={() => {
            setIsOpen(false);
            login();
          }}
        />
      )}
      {user && (
        <StepDialog
          isOpen={isOpen}
          steps={getOnboardingLoggedInDialogSteps()}
          shouldShowHeaderText
          preventOutsideDismiss
          onClose={() => setIsOpen(false)}
          onLastAction={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
